/* Evolution simulator. Shared state for panel, remote and app.
   Patterns follow the owner's diagrams; timing and blue/yellow/red inflation
   stages are illustrative, not measured pressure or verified firmware thresholds. */
(() => {
  'use strict';
  const selector='[data-kg-pdp="simulator-evolution"]';
  if(window.KinegunPDPSimulatorEvolution){window.KinegunPDPSimulatorEvolution.init(document);return;}
  const states=new WeakMap(),reduced=window.matchMedia('(prefers-reduced-motion: reduce)');
  const cycles={
    1:[[0],[1],[2],[3],[]],
    2:[[0],[0,1],[0,1,2],[0,1,2,3],[]],
    3:[[0,1],[1,2],[2,3],[0,1,2,3],[]],
    4:[[0,1,2,3],[]],
    5:[[0],[0,1],[0,1,2],[0,1,2,3],[],[0,1],[1,2],[2,3],[]]
  };
  const pressures=[30,50,80,120,160,200,240],times=[15,30,45];
  const colors=['#0065ff','#3280d3','#9cab72','#ffdb00','#ffa600','#f35908','#e50006'];
  const masks=[63,6,91,79,102,109,125,7,127,111];
  const segments=['5,1 23,1 27,4 23,7 5,7 1,4','24,8 28,5 30,8 30,25 27,29 24,25','24,35 27,31 30,35 30,52 27,55 24,52','5,54 23,54 27,57 23,60 5,60 1,57','0,35 3,31 6,35 6,52 3,55 0,52','0,8 3,5 6,8 6,25 3,29 0,25','5,27 23,27 27,30 23,33 5,33 1,30'];
  function numberHTML(value,digits){
    const text=String(value),padded=text.padStart(digits,' ');
    const shapes=[...padded].map((n,i)=>'<g transform="translate('+i*36+' 0)">'+segments.map((points,j)=>'<polygon points="'+points+'" fill="currentColor" opacity="'+(n!==' '&&(masks[+n]&(1<<j))?1:.09)+'"/>').join('')+'</g>').join('');
    return '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 '+(digits*36-6)+' 61" aria-hidden="true" focusable="false">'+shapes+'</svg><span class="evo-accessible-value">'+text+'</span>';
  }
  function rootsIn(context){const roots=[...context.querySelectorAll(selector)];if(context.matches?.(selector))roots.unshift(context);return roots;}
  function create(root,signal){
    const buttons=[...root.querySelectorAll('[data-evo-mode-key]')];
    const definitions=[...root.querySelectorAll('[data-evo-description]')];
    const available=[...new Set(definitions.map(b=>Number(b.dataset.evoModeKey)).filter(n=>cycles[n]))].sort((a,b)=>a-b);
    if(!available.length)return {destroy(){},schedule(){},choose(){}};
    let selected=available[0],level=0,duration=0,step=0,inflationStage=0,playing=true,timer=null;
    const tabs=[...root.querySelectorAll('[data-evo-view]')];
    const slider=root.querySelector('[data-evo-pressure-slider]');
    function setDisplay(name,value){root.querySelectorAll('[data-evo-display="'+name+'"]').forEach(e=>{
      if(e.dataset.evoDigits)e.innerHTML=numberHTML(value,+e.dataset.evoDigits);else e.textContent=value;
    });}
    function drawInflation(){
      const inflating=cycles[selected][step].length>0;
      root.querySelectorAll('[data-evo-inflation-stage]').forEach(e=>e.classList.toggle('on',inflating&&+e.dataset.evoInflationStage<=inflationStage+1));
    }
    function draw(){
      const active=cycles[selected][step],definition=definitions.find(b=>+b.dataset.evoModeKey===selected);
      setDisplay('pressure',pressures[level]);setDisplay('mode',selected);setDisplay('time',times[duration]);
      setDisplay('description',definition.dataset.evoDescription);setDisplay('title',definition.textContent);
      setDisplay('target',pressures[level]+' mmHg');setDisplay('duration',times[duration]+' min');
      root.querySelectorAll('[data-evo-chamber]').forEach(e=>{
        const on=active.includes(+e.dataset.evoChamber);e.classList.toggle('on',on);e.querySelector('small').textContent=on?'CON AIRE':'SIN AIRE';
      });
      root.querySelectorAll('[data-evo-segment]').forEach(e=>e.classList.toggle('on',active.includes(+e.dataset.evoSegment)));
      drawInflation();
      buttons.forEach(b=>b.setAttribute('aria-pressed',String(+b.dataset.evoModeKey===selected)));
      root.querySelectorAll('[data-evo-time]').forEach(b=>b.setAttribute('aria-pressed',String(+b.dataset.evoTime===times[duration])));
      root.classList.toggle('evo-paused',!playing);
      root.querySelectorAll('[data-evo-action="power"]').forEach(b=>{
        b.setAttribute('aria-pressed',String(playing));b.setAttribute('aria-label',playing?'Pausar animación':'Reanudar animación');
      });
      slider.value=level;slider.setAttribute('aria-valuetext','Nivel '+(level+1)+': '+pressures[level]+' mmHg');
      slider.style.setProperty('--evo-level-color',colors[level]);
      const angle=(-135+level*45)*Math.PI/180;
      const marker=root.querySelector('[data-evo-gauge-marker]');
      marker.setAttribute('transform','translate('+(110+64*Math.sin(angle))+' '+(106-64*Math.cos(angle))+')');
      root.querySelector('[data-evo-gauge-dot]').setAttribute('fill',colors[level]);
      setDisplay('phase',!playing?'Animación en pausa.':active.length?'Cámaras con aire: '+active.map(n=>n+1).join(' + '):'Liberación del aire.');
    }
    // One clock drives both chamber steps and the three cumulative arc segments.
    // Preserve the original 1400 ms chamber step, including the release phase.
    function tick(){inflationStage=(inflationStage+1)%3;if(inflationStage===0){step=(step+1)%cycles[selected].length;draw();}else drawInflation();}
    function schedule(){clearInterval(timer);timer=null;if(playing&&!reduced.matches&&!document.hidden)timer=setInterval(tick,1400/3);}
    function choose(n){if(!available.includes(n))return;selected=n;step=0;inflationStage=0;playing=true;draw();schedule();}
    function switchView(view,focus=false){
      tabs.forEach(tab=>{const on=tab.dataset.evoView===view;tab.setAttribute('aria-selected',String(on));tab.tabIndex=on?0:-1;if(on&&focus)tab.focus();});
      root.querySelectorAll('[data-evo-interface]').forEach(panel=>{panel.hidden=panel.dataset.evoInterface!==view;});
    }
    tabs.forEach((tab,i)=>{
      tab.addEventListener('click',()=>switchView(tab.dataset.evoView),{signal});
      tab.addEventListener('keydown',e=>{
        let next;
        if(e.key==='ArrowRight')next=(i+1)%tabs.length;
        else if(e.key==='ArrowLeft')next=(i+tabs.length-1)%tabs.length;
        else if(e.key==='Home')next=0;
        else if(e.key==='End')next=tabs.length-1;
        else return;
        e.preventDefault();switchView(tabs[next].dataset.evoView,true);
      },{signal});
    });
    buttons.forEach(b=>b.addEventListener('click',()=>choose(+b.dataset.evoModeKey),{signal}));
    root.querySelectorAll('[data-evo-action]').forEach(b=>b.addEventListener('click',()=>{
      switch(b.dataset.evoAction){
        case 'power':playing=!playing;draw();schedule();return;
        case 'mode':choose(available[(available.indexOf(selected)+1)%available.length]);return;
        case 'plus':level=Math.min(level+1,pressures.length-1);break;
        case 'minus':level=Math.max(level-1,0);break;
        case 'time':duration=(duration+1)%times.length;break;
        default:return;
      }
      draw();
    },{signal}));
    slider.addEventListener('input',()=>{const value=Number(slider.value);if(Number.isInteger(value)&&value>=0&&value<pressures.length){level=value;draw();}},{signal});
    root.querySelectorAll('[data-evo-time]').forEach(b=>b.addEventListener('click',()=>{const n=times.indexOf(+b.dataset.evoTime);if(n>=0){duration=n;draw();}},{signal}));
    switchView('panel');draw();schedule();return {choose,schedule,destroy(){clearInterval(timer);}};
  }
  function init(context){rootsIn(context).forEach(root=>{if(states.has(root))return;const controller=new AbortController(),simulator=create(root,controller.signal);states.set(root,{controller,simulator});});}
  document.addEventListener('click',e=>{
    const link=e.target.closest?.('a[href^="#kg-pdp-evolution-mode-"]');if(!link?.closest('[data-kg-pdp]'))return;
    const n=Number(link.hash.replace('#kg-pdp-evolution-mode-',''));
    document.querySelectorAll(selector).forEach(root=>states.get(root)?.simulator.choose(n));
  });
  document.addEventListener('shopify:section:load',e=>init(e.target));
  document.addEventListener('shopify:section:unload',e=>rootsIn(e.target).forEach(root=>{const state=states.get(root);state?.simulator.destroy();state?.controller.abort();states.delete(root);}));
  function sync(){document.querySelectorAll(selector).forEach(root=>states.get(root)?.simulator.schedule());}
  document.addEventListener('visibilitychange',sync);reduced.addEventListener('change',sync);
  window.KinegunPDPSimulatorEvolution={init};
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>init(document),{once:true});else init(document);
})();
